import React, { useEffect, useState } from 'react';
import share_icon from './image/share-icon.svg';
import styles from './ShareButton.module.scss';

const ShareButton = ({ id }) => {

    const [isMouseInside, setMouseInside] = useState(false);
    const [host, setHost] = useState('');

    useEffect(() => {
        setHost(window.location.host)
    }, [host, id]);
    const mouseEnter = () => {
        setMouseInside(true)
    };
    const mouseLeave = () => {
        setMouseInside(false)
    };

    return (
        <div className={styles["card-shareable"]}
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}>
            <img
                className="card-shareable-image"
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                src={share_icon}
                alt="share"
                />
            {(isMouseInside) ? (
                <div className={styles["social__container"]} onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
                    <ul className={styles["social__icons"]}>
                        <li className={styles["social__icons-top"]}>
                            <a
                                href={`https://www.facebook.com/sharer/sharer.php?u=www.${host}/accomodation-details?id=${id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Share on Facebook"
                            >
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                </svg>
                            </a>
                        </li>
                        <li className={styles["social__icons-bottom"]}>
                            <a
                                href={`https://twitter.com/intent/tweet?text=www.${host}/accomodation-details?id=${id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Share on X / Twitter"
                            >
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>
            ) : null}
        </div>
    )

}

export default ShareButton;